// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1n4EZ","footer":"ReportModalFilter_footer__2RXwG"};